import { render, staticRenderFns } from "./AllReceivershipSubmissions.vue?vue&type=template&id=5dc86a86&scoped=true&"
import script from "./AllReceivershipSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllReceivershipSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllReceivershipSubmissions.vue?vue&type=style&index=0&id=5dc86a86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc86a86",
  null
  
)

export default component.exports